import { ElementRef, EventEmitter, Injector, Input, Output, Renderer2, Directive } from '@angular/core';
import { BaseItemModelService } from '@fi-app/template/base-item.model';
import { TemplateLayoutHelper } from '@fi-app/template/template-layout-helper';

@Directive()
export class DocumentEditItemBase {
    @Input() templateLayoutHelper: TemplateLayoutHelper;

    @Output('close') closeEmitter = new EventEmitter<any>();
    @Output('mediaBankFileChanged') mediaBankFileChangedEmitter = new EventEmitter<any>();
    @Output() contentChange = new EventEmitter();

    IsLayoutLanguageSelected(languageId) {
        return this.languageId == languageId;
    }

    public elementRef: ElementRef<HTMLElement>;
    public renderer: Renderer2;

    @Input() item: BaseItemModelService;
    @Input() selectedColumn: number;
    @Input() languageId: number;

    constructor(public injector: Injector) {
        this.elementRef = injector.get(ElementRef);
        this.renderer = injector.get(Renderer2);
    }

    close() {
        this.closeEmitter.emit();
    }
}
